import React from 'react'

import Layout from '../components/Layout'
import {Posts} from '../components/Main'

const Music = ({ location }) => {
    return (
        <Layout location={location}>
            <Posts pageTitle={'Music'} category={['music']} />
        </Layout>
    )
}

export default Music
